import { MARIGOLD } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UISelect from 'UIComponents/input/UISelect';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import ValidationLabelIcon from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationLabelIcon';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { EnrollmentIssuesOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/helpOptions';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { OPEN_QUERY_PARAM } from 'automation-ui-canvas/components/flow-header/menu-bar/MenuBar';
import { QuestionIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TROUBLESHOOT_ENROLLMENT_ALERT = {
  alert: {
    id: 'TROUBLESHOOT_ENROLLMENT_ALERT',
    actionId: 'enrollment',
    alertType: 'info',
    borderStyle: 'warning',
    bannerStyle: 'warning',
    getBannerTitle: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.testV2.simulatePanel.startSection.eventEnrollment.bannerUnpredictable"
    }),
    getMessage: ({
      viewData,
      history,
      onCancel
    }) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "automation.testV2.simulatePanel.useTroubleshootEnrollment_jsx",
      elements: {
        Link: UILink
      },
      options: {
        onClick: () => {
          onCancel === null || onCancel === void 0 || onCancel();
          atomicQueryUpdate({
            [OPEN_QUERY_PARAM]: EnrollmentIssuesOption.id,
            objectId: viewData.recordId
          }, [], history);
        }
      }
    }),
    getIcon: () => {
      return /*#__PURE__*/_jsx(IconCircle, {
        icon: QuestionIcon,
        backgroundColor: "fill-accent-yellow-default",
        color: "text-primary-on-fill-default",
        borderColor: "fill-accent-yellow-pressed",
        borderStyle: "solid",
        size: "300",
        padding: "50"
      });
    },
    executionShouldHalt: true
  },
  shouldShowValidationChecks: false
};
export function makeEventEnrollmentFlowAlert({
  flow,
  recordId,
  context
}) {
  const getAlertMeta = () => {
    if (context.shouldOverrideEventEnrollment === undefined) {
      return {
        type: 'warning',
        icon: /*#__PURE__*/_jsx(UIIcon, {
          size: 24,
          name: "warning",
          color: MARIGOLD
        }),
        bannerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.testV2.simulatePanel.startSection.eventEnrollment.bannerUnpredictable"
        }),
        text: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation.testV2.simulatePanel.startSection.eventEnrollment.unpredictable",
          options: {
            recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
              objectTypeId: flow.objectTypeId,
              id: recordId
            })
          }
        })
      };
    }
    if (context.wouldEnroll) {
      return {
        type: 'success',
        icon: /*#__PURE__*/_jsx(ValidationLabelIcon, {
          status: "PASSED"
        }),
        bannerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'automation.testV2.simulatePanel.startAlerts.startedAutomatically'
        }),
        text: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation.testV2.simulatePanel.startSection.eventEnrollment.successAutomatic",
          options: {
            recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
              objectTypeId: flow.objectTypeId,
              id: recordId
            })
          }
        })
      };
    } else {
      return {
        type: 'danger',
        icon: /*#__PURE__*/_jsx(ValidationLabelIcon, {
          status: "FAILED"
        }),
        bannerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'automation.testV2.simulatePanel.startAlerts.notExpectedToStartAutomatically'
        }),
        text: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'automation.testV2.simulatePanel.startSection.eventEnrollment.rejectAutomatic',
          options: {
            recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
              objectTypeId: flow.objectTypeId,
              id: recordId
            })
          }
        })
      };
    }
  };
  const alertMeta = getAlertMeta();
  return {
    id: 'EventEnrollmentAlert',
    actionId: 'enrollment',
    alertType: alertMeta.type,
    borderStyle: alertMeta.type,
    bannerStyle: alertMeta.type,
    getBannerTitle: () => alertMeta.bannerTitle,
    getIcon: () => alertMeta.icon,
    getMessage: ({
      viewData
    }) => /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-y-3",
        children: alertMeta.text
      }), /*#__PURE__*/_jsx(UISelect, {
        buttonUse: "form-on-dark",
        placeholder: I18n.text('automation.testV2.simulatePanel.startSection.eventEnrollmentOptions.placeholder'),
        onChange: ({
          target: {
            value
          }
        }) => {
          viewData.setShouldOverrideEventEnrollment(value === 'COMPLETES');
        },
        defaultValue: context.shouldOverrideEventEnrollment ? 'COMPLETES' : undefined,
        options: [{
          text: I18n.text('automation.testV2.simulatePanel.startSection.eventEnrollmentOptions.completes'),
          value: 'COMPLETES'
        }, {
          text: I18n.text('automation.testV2.simulatePanel.startSection.eventEnrollmentOptions.doesNotComplete'),
          value: 'DOES_NOT_COMPLETE'
        }]
      })]
    }),
    context,
    executionShouldHalt: !context.shouldOverrideEventEnrollment
  };
}
export const NO_CRITERIA_SET_ALERT = {
  alert: {
    id: 'NO_CRITERIA_SET_ALERT',
    actionId: 'enrollment',
    alertType: 'warning',
    borderStyle: 'warning',
    bannerStyle: 'warning',
    getIcon: () => {
      return /*#__PURE__*/_jsx(UIIcon, {
        size: 24,
        name: "warning",
        color: MARIGOLD
      });
    },
    getBannerTitle: ({
      enrollType
    }) => enrollType === 'DYNAMIC' ? I18n.text('automation.testV2.simulatePanel.startAlerts.notExpectedToStartAutomatically') : I18n.text('automation.testV2.simulatePanel.startAlerts.notExpectedToStartManually'),
    getMessage: ({
      flow
    }) => {
      if (flow.enrollmentSchedule) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'automation.testV2.simulatePanel.startAlerts.wouldNotEnrollNoStartingListScheduled'
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: 'automation.testV2.simulatePanel.startAlerts.wouldNotEnrollNoStartingList_cob',
        objectTypeId: flow.objectTypeId
      });
    }
  },
  shouldShowValidationChecks: false
};
export const WILL_NOT_ENROLL_ALERT = {
  alert: {
    id: 'WILL_NOT_ENROLL_ALERT',
    actionId: 'enrollment',
    alertType: 'danger',
    borderStyle: 'danger',
    bannerStyle: 'danger',
    getIcon: () => {
      return /*#__PURE__*/_jsx(ValidationLabelIcon, {
        status: "FAILED"
      });
    },
    getMessage: ({
      viewData,
      flow
    }) => /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: viewData.enrollType === 'DYNAMIC' ? 'automation.testV2.simulatePanel.startAlerts.willNotEnrollAutomatic' : 'automation.testV2.simulatePanel.startAlerts.willNotEnrollManual',
      options: {
        recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
          objectTypeId: flow.objectTypeId,
          id: viewData.recordId
        })
      }
    }),
    getBannerTitle: ({
      enrollType
    }) => enrollType === 'DYNAMIC' ? I18n.text('automation.testV2.simulatePanel.startAlerts.notExpectedToStartAutomatically') : I18n.text('automation.testV2.simulatePanel.startAlerts.notExpectedToStartManually')
  },
  shouldShowValidationChecks: true
};
export const MANUAL_ENROLLMENT_ALERT = {
  alert: {
    id: 'MANUAL_ENROLLMENT_ALERT',
    actionId: 'enrollment',
    alertType: 'success',
    borderStyle: 'success',
    bannerStyle: 'success',
    getIcon: () => /*#__PURE__*/_jsx(ValidationLabelIcon, {
      status: "PASSED"
    }),
    getBannerTitle: () => {
      return I18n.text('automation.testV2.simulatePanel.startAlerts.startedManually');
    },
    getMessage: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.testV2.simulatePanel.startAlerts.startedManually"
    })
  },
  shouldShowValidationChecks: true
};
export const AUTOMATIC_ENROLLMENT_ALERT = {
  alert: {
    id: 'AUTOMATIC_ENROLLMENT_ALERT',
    actionId: 'enrollment',
    alertType: 'success',
    borderStyle: 'success',
    bannerStyle: 'success',
    getIcon: () => /*#__PURE__*/_jsx(ValidationLabelIcon, {
      status: "PASSED"
    }),
    getBannerTitle: () => {
      return I18n.text('automation.testV2.simulatePanel.startAlerts.startedAutomatically');
    },
    getMessage: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.testV2.simulatePanel.startAlerts.startedAutomatically"
    })
  },
  shouldShowValidationChecks: true
};
export const makeUnsupportedListBranchAlert = ({
  context,
  actionId
}) => ({
  id: 'UNSUPPORTED_LIST_BRANCH_ALERT',
  actionId,
  alertType: 'warning',
  borderStyle: context.isUnpredictableBranch && !context.isOverriden ? 'warning' : 'success',
  getMessage: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation.testV2.simulatePanel.startAlerts.unsupportedFilter"
  }),
  context,
  getIcon: () => {
    return /*#__PURE__*/_jsx(IconCircle, {
      icon: QuestionIcon,
      backgroundColor: "fill-accent-yellow-default",
      color: "text-primary-on-fill-default",
      borderColor: "fill-accent-yellow-pressed",
      borderStyle: "solid",
      size: "300",
      padding: "50"
    });
  },
  executionShouldHalt: context.isUnpredictableBranch && !context.isOverriden
});
export const makeUnpredictableStaticBranchAlert = ({
  context,
  actionId
}) => ({
  id: 'UNPREDICTABLE_STATIC_BRANCH_ALERT',
  actionId,
  alertType: 'warning',
  borderStyle: !context.isOverriden ? 'warning' : 'success',
  getMessage: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation.testV2.simulatePanel.startAlerts.unsupportedFieldData"
  }),
  context,
  getIcon: () => {
    return /*#__PURE__*/_jsx(IconCircle, {
      icon: QuestionIcon,
      backgroundColor: "fill-accent-yellow-default",
      color: "text-primary-on-fill-default",
      borderColor: "fill-accent-yellow-pressed",
      borderStyle: "solid",
      size: "300",
      padding: "50"
    });
  },
  executionShouldHalt: !context.isOverriden
});